import { InjectionToken } from '@angular/core';
import { APP_CONSTANTS } from 'app/app.config';

export interface MasterDataConfig {
  REMOTE: {
    GENDERS: string;
  };
}

const baseURL = APP_CONSTANTS.API_URL;

export const MASTER_DATA_CONSTANTS: MasterDataConfig = {
  REMOTE: {
    GENDERS: `${baseURL}users/genders/all`
  }
};

export const MASTER_DATA_CONFIG = new InjectionToken<MasterDataConfig>('master-data.config');
